import Vue from 'vue';
import Router from 'vue-router';

import Home from 'views/Home.vue';
// route level code-splitting
// this generates a separate chunk (about.[hash].js) for this route
// which is lazy-loaded when the route is visited.
// 登录
const Login = () => import(/* webpackChunkName: "about" */ 'views/Login.vue');
// 支付
const Pay = () => import(/* webpackChunkName: "about" */ 'views/Pay.vue');
// 二维码支付
const Payqrcode = () => import(/* webpackChunkName: "about" */ 'views/Payqrcode.vue');
// 支付返回页
const PayBack = () => import(/* webpackChunkName: "about" */ 'views/PayBack.vue');
// 讲解页
const Explain = () => import(/* webpackChunkName: "about" */ 'views/Explain.vue');
// 答题页
const Exercises = () => import(/* webpackChunkName: "about" */ 'views/Exercises.vue');
// 证书
const Certificate = () => import(/* webpackChunkName: "about" */ 'views/Certificate.vue');
// 个人中心
const User = () => import(/* webpackChunkName: "about" */ 'views/User.vue');

Vue.use(Router);

export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/register',
      name: 'register',
      component: Login
    },
    {
      path: '/forgetPwd',
      name: 'forgetPwd',
      component: Login
    },
    {
      path: '/pay',
      name: 'pay',
      component: Pay
    },
    {
      path: '/payqrcode',
      name: 'payqrcode',
      component: Payqrcode
    },
    {
      path: '/payback',
      name: 'payback',
      component: PayBack
    },
    {
      path: '/explain',
      name: 'explain',
      component: Explain
    },
    {
      path: '/exercises',
      name: 'exercises',
      component: Exercises
    },
    {
      path: '/certificate',
      name: 'certificate',
      component: Certificate
    },
    {
      path: '/user',
      name: 'user',
      component: User
    }
  ]
});
